"use strict";
/**
 * @packageDocumentation
 * @module Logger.Services
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithLogger = void 0;
var LoggerBuilder_1 = require("../builder/LoggerBuilder");
var WithLogger = /** @class */ (function () {
    function WithLogger(builder) {
        if (builder === void 0) { builder = LoggerBuilder_1.LoggerBuilder.initial(); }
        this.builder = builder;
        this.logger = builder.get();
    }
    /**
     * @deprecated Please use updateLoggerOption instead, it's adapted logger builder
     * update current logger object
     *
     * @param fn - perform anything you needs to create new logger object, logger in parameters has no side effect
     */
    WithLogger.prototype.updateLogger = function (fn) {
        this.logger = fn(this.logger.copy());
    };
    /**
     * update logger options and settings
     *
     * @param fn - update logger option via builder
     */
    WithLogger.prototype.updateLoggerOption = function (fn) {
        this.builder = this.builder.updateOption(fn);
        this.logger = this.builder.get();
    };
    return WithLogger;
}());
exports.WithLogger = WithLogger;
//# sourceMappingURL=WithLogger.js.map